export default "__VITE_ASSET__MMpD2qzn__"